import { connect } from 'react-redux';
import ReadOnlyContent from 'nucleus-widgets/renderers/readOnlyContent';

export default connect((state) => {
  return {
    isGuest: true,
    theme: state.website.theme,
    imageLookup: state.imageLookup,
    browserFeatures: state.browserFeatures,
    layoutItems: state.website.layoutItems,
    widgetFactory: state.widgetFactory,
    guestTranslate: state.text.translate
  };
})(ReadOnlyContent);
